<template>
  <div>
    <v-text-field
      v-model="cmpValue"
      :label="label"
      :placeholder="placeholder"
      :readonly="readonly"
      :disabled="disabled"
      :outlined="outlined"
      :dense="dense"
      :hide-details="hideDetails"
      :error="error"
      :error-messages="errorMessages"
      :clearable="clearable"
      :prefix="prefix"
      inputmode="numeric"
      @keypress="keyPress"
    ></v-text-field>
  </div>
</template>

<script>
import Config from '@/config';
import isNumber from 'lodash/isNumber';

import { formatNumber } from '@/filters/accounting';

export default {
  model: { prop: "value", event: "input" },
  props: {
    value: { type: Number },
    label: { type: String },
    placeholder: { type: String },
    readonly: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    hideDetails: { type: [Boolean, String], default: false },
    errorMessages: { type: [Array, String], default: () => [] },
    disabled: { type: Boolean, default: false },
    outlined: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
    prefix: { type: String, default: () => Config.get('MONEY_SYMBOL') },
    precision: { type: Number, default: () => 0 },
  },
  computed: {
    cmpValue: {
      get: function() {
        return isNumber(this.value)
          ? formatNumber(this.value, { precision: this.precision })
          : null;
      },
      set: function(newValue) {
        this.$emit("input", this.machineFormat(newValue));
      }
    }
  },
  methods: {
    keyPress($event) {
      // console.log($event.keyCode); //keyCodes value
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      // if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
    },

    machineFormat(number) {

      if (number) {
        const cleanNumber = this.cleanNumber(number);
        const paddedNumber = cleanNumber.padStart(this.precision + 1, '0');

        const formattedNumber =
          paddedNumber.substring(
            0,
            paddedNumber.length - parseInt(this.precision)
          ) +
          "." +
          paddedNumber.substring(
            paddedNumber.length - parseInt(this.precision),
            paddedNumber.length
          );

        return Number(formattedNumber);
      } else {
        return null;
      }
    },

    cleanNumber(number) {
      return Number(number.replace(/[.|,]/g, '')).toString();
    },
  }
};
</script>

